const getSubmitButtonState = (formData: any) => {
  const { commitHash, branch, buildConfigType, pipelineableId, tag } = formData;

  let isSubmitDisabled = false;
  let disabledText = '';

  if (!pipelineableId) {
    isSubmitDisabled = true;
    disabledText = 'To start a build select a pipeline or workflow.';
  }
  if (buildConfigType === 'basic' && !branch) {
    isSubmitDisabled = true;
    disabledText = 'To start a build select a branch';
  }
  if (buildConfigType === 'advanced') {
    const noneSelected = !branch && !tag && !commitHash;
    const multipleSelected = (branch && tag) || (branch && commitHash) || (tag && commitHash);
    if (noneSelected || multipleSelected) {
      disabledText = 'To start a build configure exactly one of the following: branch, Git tag, or commit hash.';
      isSubmitDisabled = true;
    }
  }
  return {
    disabledText,
    isSubmitDisabled,
  };
};

export default getSubmitButtonState;
